import { useState } from 'react'

import { usePermissions } from 'commons/customHooks/useAuth'
import i18n from 'commons/libs/i18n'
import { ACTIONS_SCREENS, SCREENS } from 'commons/utils/permissions'
import { Checkbox, Divider, Icon, SlimButton } from 'components'
import type { ActionPerm } from 'components/Structures/Header/constants'
import { ViewBy, type ViewByType } from 'container/ManageOrders'
import { Controller, useFormContext } from 'react-hook-form'
import { theme } from 'styles/theme/hav-theme'

import ModalReport from '../../../../../container/ManageOrders/components/ModalReport'
import * as S from './styles'

type SelectionTabProps = {
  viewBy: ViewByType
  setViewBy: (value: ViewByType) => void
  disabledHideStatusChecked: boolean
}

export const SelectionTab = ({
  viewBy,
  setViewBy,
  disabledHideStatusChecked,
}: SelectionTabProps) => {
  const [openReportModal, setOpenReportModal] = useState(false)
  const { verifyPermission } = usePermissions()
  const { control } = useFormContext()

  function shouldDisable(action: ActionPerm) {
    return !verifyPermission(SCREENS.MANAGE, action)
  }

  return (
    <>
      <S.SelectionTabWrapper>
        <div>
          <S.SelectionTabBtn
            onClick={() => {
              setViewBy(ViewBy.ORDERS)
            }}
            selected={viewBy === ViewBy.ORDERS}
          >
            {i18n.t('common.orders')}
          </S.SelectionTabBtn>
          <S.SelectionTabBtn onClick={() => setViewBy(ViewBy.OVS)} selected={viewBy === ViewBy.OVS}>
            {i18n.t('common.salesOrders')}
          </S.SelectionTabBtn>
          {viewBy === ViewBy.OVS && (
            <S.SelectionTabCheckboxWrapper>
              <Controller
                control={control}
                name="hideStatusChecked"
                render={({ field }) => (
                  <Checkbox
                    bold
                    checked={field.value}
                    disabled={disabledHideStatusChecked}
                    label={i18n.t('buttons.hideCanceled')}
                    onChange={(e) => {
                      field.onChange(e.target.checked)
                    }}
                    size="small"
                  />
                )}
              />
            </S.SelectionTabCheckboxWrapper>
          )}
        </div>
        <S.SlinButtonWrapper>
          <SlimButton
            content={i18n.t('buttons.requestReport')}
            disabled={shouldDisable(ACTIONS_SCREENS.DOWNLOAD)}
            icon={<Icon icon="file-up" size="16" />}
            onClick={() => setOpenReportModal(true)}
            type="button"
            variant="info"
          />
        </S.SlinButtonWrapper>
      </S.SelectionTabWrapper>

      <Divider
        length={`calc(100% + 2 * ${theme.spacing.xm})`}
        marginLeft={`-${theme.spacing.xm}`}
      />

      {openReportModal && (
        <ModalReport open={openReportModal} setOpen={setOpenReportModal} viewBy={viewBy} />
      )}
    </>
  )
}
